import { CheerzApiPromoCode } from "@Types/api/promoCode";
import { PromoCodeContent } from "@Types/cart";

export const convertFromPromoCodeContentToApi = (
  promoCodeContent: PromoCodeContent
): CheerzApiPromoCode => {
  return {
    promo_code: promoCodeContent.promoCode ? promoCodeContent.promoCode : null,
  };
};
